import { ButtonConfig, Client } from "@interfaces";
import { parseColour } from "./colour";
import { getBorderRadius, getBorderWidth } from "./tailwind";

export function calculateButtonStyle(buttonConfig: ButtonConfig, client: Client) {
    let backgroundColor,
        color = null,
        borderColor = null;

    if (buttonConfig?.background?.type === "primary") {
        backgroundColor = client.brandColours.primary || "black";
    } else if (buttonConfig?.background?.type === "secondary") {
        backgroundColor = client.brandColours.secondary || "black";
    } else if (buttonConfig?.background?.type === "hex") {
        backgroundColor = buttonConfig.background.value;
    }

    if (buttonConfig?.textColour?.includes("#")) {
        color = buttonConfig.textColour;
    } else if(buttonConfig?.textColour === 'auto') {
        color = selectContrastColour(backgroundColor);
    }

    if (buttonConfig?.borderColour?.includes("#")) {
        borderColor = buttonConfig.borderColour;
    } else if(buttonConfig?.borderColour === 'auto') {
        borderColor = selectContrastColour(backgroundColor);
    }

    return { backgroundColor, color, borderColor };
}

export function calculateButtonClasses(buttonConfig: ButtonConfig) {
    const classes = ["font-sans"];

    if (buttonConfig?.bold) {
        classes.push("font-bold");
    }

    if (
        buttonConfig?.background?.type === "custom" &&
        buttonConfig?.background?.value &&
        typeof buttonConfig?.background?.value === "string" &&
        buttonConfig?.background?.value?.includes("bg-")
    ) {
        classes.push(buttonConfig.background.value);
    } else {
        classes.push("bg-black");
    }

    if (buttonConfig?.textColour?.includes("text-")) {
        classes.push(buttonConfig.textColour);
    } else {
        classes.push("text-white");
    }
    if (buttonConfig?.borderColour?.includes("border-")) {
        classes.push(buttonConfig.borderColour, "border");
    }

    if (buttonConfig?.borderRadius) {
        classes.push(getBorderRadius(buttonConfig.borderRadius));
    }

    if (buttonConfig?.borderWidth) {
        classes.push(getBorderWidth(buttonConfig.borderWidth));
    }

    if(buttonConfig?.fullWidth) {
        classes.push("w-full");
    }

    if (buttonConfig?.textSize) {
        switch (buttonConfig.textSize) {
            case "small":
                classes.push("text-sm", "gap-1 md:gap-2 px-2 md:px-4 py-1 md:py-2");
                break;
            case "regular":
                classes.push("text-base", "gap-1 md:gap-2 px-4 md:px-6 py-2 md:py-3");
                break;
            case "large":
                classes.push("text-lg", "gap-1 md:gap-2 px-4 md:px-6 py-2 md:py-3");
                break;
            case "xlarge":
                classes.push("text-xl", "gap-2 md:gap-4 px-6 md:px-8 py-3 md:py-4");
                break;
            case "xxlarge":
                classes.push("text-2xl", "gap-2 md:gap-4 px-6 md:px-8 py-3 md:py-4");
                break;
            default:
                classes.push("text-base", "gap-1 md:gap-2 px-4 md:px-6 py-2 md:py-4");
                break;
        }
    } else {
        classes.push("text-base", "gap-1 md:gap-2 px-4 md:px-6 py-2 md:py-4");
    }

    return classes;
}

const colourIsLight = function (r, g, b) {
    // Counting the perceptive luminance
    // human eye favors green color...
    const a = 1 - (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return a < 0.5;
};

const selectContrastColour = function (bgHex) {
    const parsedColor = parseColour(bgHex);
    let [r, g, b] = parsedColor.values;
    const textColour = colourIsLight(r, b, g) ? "black" : "white";
    return textColour;
}
